export default {
  bannerBottomData: [
    {
      firstLineText: '19年+',
      secondLineText: '服务经验',
    },
    {
      firstLineText: '502万+',
      secondLineText: '企业服务',
    },
    {
      firstLineText: '2.7亿+',
      secondLineText: '个人用户',
    },
    {
      firstLineText: '121亿+',
      secondLineText: '总签署量',
    },
    {
      firstLineText: '24x365小时',
      secondLineText: '管家式服务',
    },
  ],
  // e签宝开放产品体系数据
  systemList: [
    {
      key: 1,
      imgSrc: require('../../assets/images/sem-api/system-one.png'),
      title: '身份认证',
      descList: ['提供个人和企业多种信息核验、实名认证能力，多渠道权威数据直接授权，支持页面和纯API两种接入方式。'],
      kindList: [
        {
          key: 1,
          icon: require('../../assets/images/sem-api/system-one-one.png'),
          text: '人脸识别'
        },
        {
          key: 2,
          icon: require('../../assets/images/sem-api/system-one-two.png'),
          text: '统一认证'
        },
      ]
    },
    {
      key: 2,
      imgSrc: require('../../assets/images/sem-api/system-two.png'),
      title: '电子签名',
      descList: ['异地秒签免邮寄，电子合同1分钟批量签署上千份；','签字和实名信息实时校验；','模块编辑使用权限实时管控。'],
      kindList: [
        {
          key: 1,
          icon: require('../../assets/images/sem-api/system-two-one.png'),
          text: '批量签'
        },
        {
          key: 2,
          icon: require('../../assets/images/sem-api/system-two-two.png'),
          text: '扫码签'
        },
        {
          key: 3,
          icon: require('../../assets/images/sem-api/system-two-three.png'),
          text: '模板发起'
        },
      ]
    },
    {
      key: 3,
      imgSrc: require('../../assets/images/sem-api/system-four.png'),
      title: '合同管理',
      descList: ['为企业提供智能电子合同“签署+管控”解决方案：审批流程拖曳式灵活配置；','自动形成业务台账数据报表；','低成本api方案业务数据回传。'],
      kindList: [
        {
          key: 1,
          icon: require('../../assets/images/sem-api/system-three-one.png'),
          text: '多级审批流'
        },
        {
          key: 2,
          icon: require('../../assets/images/sem-api/system-three-two.png'),
          text: '智能归档'
        },
        {
          key: 3,
          icon: require('../../assets/images/sem-api/system-three-three.png'),
          text: '智能比对'
        },
      ]
    },
    {
      key: 4,
      imgSrc: require('../../assets/images/sem-api/system-three.png'),
      title: '印章管理',
      descList: ['签章能力中台化，统一向业务侧提供用印能力；','电子印章、物理印章一套系统管控；','印章外带管理；','OCR识别比对。'],
      kindList: [
        {
          key: 1,
          icon: require('../../assets/images/sem-api/system-four-one.png'),
          text: '印控设备'
        },
        {
          key: 2,
          icon: require('../../assets/images/sem-api/system-four-two.png'),
          text: '电子印章'
        },
      ]
    },
  ],
  // 业务系统部署方式数据
  arrangeMethodList: [
    {
      key: 1,
      imgSrc: require('../../assets/images/sem-api/arrange-one.png'),
      title: '公有云API集成',
      arrangeMethodText: '部署方式：公有云',
      insertMethodText: '接入方式：API',
      applicableObjText: '适用对象：中大型企业组织',
      otherDesc: '以API集成的方式将电子签名功能嵌入自有业务系统'
    },
    {
      key: 2,
      imgSrc: require('../../assets/images/sem-api/arrange-two.png'),
      title: '混合云本地化部署',
      arrangeMethodText: '部署方式：混合云',
      insertMethodText: '接入方式：API',
      applicableObjText: '适用对象：集团型企业组织',
      otherDesc: '本地化部署，合同文件原文不出本地，保障私密数据安全可控'
    },
  ],
  // 接入流程数据
  accessProcessOneLineList: [
    {
      key: 1,
      imgSrc: require('../../assets/images/sem-api/flow-path-one.png'),
      text: '1.注册认证',
      desc: '注册e签宝账户，完成企业实名认证',
    },
    {
      key: 2,
      imgSrc: require('../../assets/images/sem-api/flow-path-two.png'),
      text: '2.开启沙箱',
      desc: '开启沙箱服务，沙箱环境联调测试',
    },
    
  ],
  accessProcessTwoLineList: [
    {
      key: 1,
      imgSrc: require('../../assets/images/sem-api/flow-path-four.png'),
      text: '4.验收上线',
      desc: '技术验收，成功对接上线',
    },
    {
      key: 2,
      imgSrc: require('../../assets/images/sem-api/flow-path-three.png'),
      text: '3.创建应用',
      desc: '应用管理页，创建线上对接应用',
    },
  ],
  // 无忧服务，极速上线数据
  freeServiceList: [
    {
      key: 1,
      title: '灵活自定义接口',
      desc: ['100+原子接口满足深度融合需求;', '遵循RESTful API接口设计规范;', '结构清晰，高效易查阅;'],
      imgSrc: require('../../assets/images/sem-api/api-one.png'),
    },
    {
      key: 2,
      title: '最佳实践',
      desc: ['新手指南，一步发起;', '丰富的签署场景最佳实践;', '10+真实场景接入案例;'],
      imgSrc: require('../../assets/images/sem-api/api-two.png'),
    },
    {
      key: 3,
      title: '多语言DEMO',
      desc: ['多语言demo提升接入效率;'],
      imgSrc: require('../../assets/images/sem-api/api-three.png'),
    },
    {
      key: 4,
      title: '开发者接入助手',
      desc: ['傻瓜式对接方案量身定做;', '根据业务需求自动生成对接方案;', '支持多场景个性化需求;'],
      imgSrc: require('../../assets/images/sem-api/api-four.png'),
    },
    {
      key: 5,
      title: 'API在线调试',
      desc: ['在线API接口调试;', '签署服务、认证服务、模板、账号四类接口在线调试;'],
      imgSrc: require('../../assets/images/sem-api/api-five.png'),
    },
    {
      key: 6,
      title: '全流程陪跑',
      desc: ['高品质售后全流程咨询;', ' 专属方案设计及对接指导;', '专属客户成功CSM经理;'],
      imgSrc: require('../../assets/images/sem-api/api-six.png'),
    },
  ],
  // 客户案例
  orgList: {
    title: '客户案例',
    orgTypeList: ['人力资源', '地产租房', '互联网+', '银行金融', '零售制造', '汽车物流', '教育旅游'],
    imgs: ['humanRes', 'logistics', 'hlw', 'bank', 'lszz', 'qqwl', 'jjly'].map(item => {
      return require(`@/assets/images/${item}.png`)
    }),
  },
}
